import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import BookingAffiliationTable from '../../components/affiliates/BookingAffiliationTable';
import { getAffiliateById } from '../../services/Affiliates';
import PrivateWrapper from '../../layouts/Private';
import Status from '../../components/common/DataStatus';

const AffiliateDetails = () => {
  const { id } = useParams();

  const [dataLoaded, setDataLoaded] = useState(false);
  const [affiliateDetails, setAffiliateDetails] = useState({
    id,
    name: '',
    email: '',
    createdAt: '',
    status: '',
    affiliatedBookings: [],
  });

  useEffect(() => {
    setDataLoaded(false);
    getAffiliateById(id, true).then((r) => {
      setAffiliateDetails({
        id: r.id,
        name: `${r.firstName} ${r.lastName}`,
        email: r.email,
        createdAt: r.createdAt,
        status: r.status,
        affiliatedBookings: r.bookingAffliliations || [],
      });
      setDataLoaded(true);
    });
  }, [id]);

  return (
    <PrivateWrapper
      pageName={
        affiliateDetails?.name ? `${affiliateDetails?.name} -  Details` : 'Affiliate Details'
      }
    >
      <Box m={2}>
        <Box mb={3} mt={2}>
          <Grid container sx={{ mb: 2 }}>
            <Grid
              item
              xs={6}
              container
              alignItems="flex-start"
              justify="flex-start"
              direction="row"
            >
              <Typography>Name:&nbsp;</Typography>
              <Typography>{affiliateDetails.name}</Typography>
            </Grid>
            <Grid
              item
              xs={6}
              container
              alignItems="flex-start"
              justify="flex-start"
              direction="row"
            >
              <Typography>Email:&nbsp;</Typography>
              <Typography>{affiliateDetails.email}</Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid
              item
              xs={6}
              container
              alignItems="flex-start"
              justify="flex-start"
              direction="row"
            >
              <Typography>Status:&nbsp;</Typography>
              <Status value={affiliateDetails.status} statusFor="affiliate" />
            </Grid>
            <Grid
              item
              xs={6}
              container
              alignItems="flex-start"
              justify="flex-start"
              direction="row"
            >
              <Typography>CreatedAt:&nbsp;</Typography>
              <Typography>{affiliateDetails.createdAt}</Typography>
            </Grid>
          </Grid>
        </Box>
        <Box mt={3}>
          {affiliateDetails.affiliatedBookings && (
            <BookingAffiliationTable
              dataLoaded={dataLoaded}
              affiliatedBookings={affiliateDetails.affiliatedBookings}
            />
          )}
        </Box>
      </Box>
    </PrivateWrapper>
  );
};

export default AffiliateDetails;
